import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'dram-capital-banner',
  templateUrl: './dram-capital-banner.component.html',
  styleUrls: ['./dram-capital-banner.component.css']
})
export class DramCapitalBannerComponent {
  icons = {
    sphere3: 'assets/images/sphere-3.png'
  };

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollY = window.scrollY;

    const sphereLeft = document.querySelector('.sphere-left') as HTMLElement;
    const sphereRight = document.querySelector('.sphere-right') as HTMLElement;

    if (sphereLeft) sphereLeft.style.transform = `translateY(${scrollY * 0.1}px)`;
    if (sphereRight) sphereRight.style.transform = `translateY(${scrollY * 0.25}px)`;
  }
}
